import React from "react";

// CSS
import "./Technologies.css";

const technologies = {
  frontend: [
    "/images/technologies/ReactJS.webp",
    "/images/technologies/NextJS.webp",
    "/images/technologies/GatsbyJS.webp",
    "/images/technologies/Bootstrap.webp",
    "/images/technologies/Sass.webp",
  ],
  backend: [
    "/images/technologies/ExpressJS.webp",
    "/images/technologies/CodeIgniter.webp",
    "/images/technologies/WordPress.webp",
    "/images/technologies/NodeJS.webp",
    "/images/technologies/PHP.webp",
  ],
  database: [
    "/images/technologies/MySQL.webp",
    "/images/technologies/PostgreSQL.webp",
  ],
  cloud: [
    "/images/technologies/Firebase.webp",
    "/images/technologies/GoogleCloud.webp",
    "/images/technologies/AWS.webp",
    "/images/technologies/Azure.webp",
  ],
  types: [
    {
      title: "Front End",
      name: "frontend",
    },
    {
      title: "Back End",
      name: "backend",
    },
    {
      title: "Database",
      name: "database",
    },
    {
      title: "Cloud",
      name: "cloud",
    },
  ],
};

const Technologies = () => {
  const [technology, setTechnology] = React.useState("frontend");

  const selecttedTechnologies =
    technology === "frontend"
      ? technologies.frontend
      : technology === "backend"
        ? technologies.backend
        : technology === "database"
          ? technologies.database
          : technology === "cloud"
            ? technologies.cloud
            : null;

  return (
    <section className="section-spacing bg-light">
      <div className="container">
        <div className="text-left mb-5 small-container">
          <h2 className="fs-1 m-0 lh-normal bold fst-normal text-uppercase">
            <span className="text-blue">Technology solutions</span> all under
            one roof
          </h2>
        </div>

        <div className="col-md-6 d-flex flex-column flex-sm-row justify-content-between pt-5">
          {technologies.types.map((type, index) => (
            <div className="mb-4 mb-sm-0" key={index}>
              <div
                className={`section-title fs-4 ${
                  technology === type.name ? "text-green" : "text-toggle-dark"
                }`}
                onKeyDown={() => setTechnology(type.name)}
                onClick={() => setTechnology(type.name)}
                role="button"
                tabIndex={0}
              >
                {type.title}
              </div>
              {technology === type.name ? (
                <div className="line-break bg-green rounded mt-2 w-100" />
              ) : (
                ""
              )}
            </div>
          ))}
        </div>

        <div className="col-lg-8">
          <div className="row pt-5">
            {selecttedTechnologies.map((technologyImgPath, index) => (
              <div className="col-sm-4 col-md-2 col-6 mb-5" key={index}>
                <img
                  src={technologyImgPath}
                  className="img-fluid"
                  alt="alternative"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Technologies;
